"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_native_1 = require("react-native");
var DEFAULT_OPACITY = 0.4;
var DURATION_PREVENT = 200;
var _lastTime = 0;
var preventDoublePress = function (func, event) {
    if (typeof func !== 'function')
        return;
    var executedTime = new Date().getTime();
    if (executedTime - _lastTime > DURATION_PREVENT) {
        func(event);
        _lastTime = executedTime;
    }
};
var pressEventListeners = {};
var Button = function (props) {
    var style = props.style, activeOpacity = props.activeOpacity, children = props.children, onLayout = props.onLayout, onLongPress = props.onLongPress, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onRef = props.onRef;
    var hoverProps = !!onMouseEnter && !!onMouseLeave ? { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } : {};
    var handlePress = function (e) {
        var noPrevent = props.noPrevent, onPress = props.onPress, id = props.id;
        if (!onPress)
            return;
        noPrevent ? onPress(e) : preventDoublePress(onPress, e);
        if (typeof id === 'string' && id !== '' && typeof pressEventListeners[id] === 'function') {
            pressEventListeners[id](e);
        }
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, __assign({ ref: onRef }, hoverProps, { onLongPress: onLongPress, onLayout: onLayout, activeOpacity: activeOpacity || DEFAULT_OPACITY, onPress: handlePress, style: style }), children));
};
exports.default = Button;
//# sourceMappingURL=Button.js.map